export const client_id = "39d43ae5588845ea807b5c6343b1f745";
export const client_secret = "137a62a7a483439e8c4d8cccf306fce9";
export const url_get_token = "https://oauth.yandex.ru/token";
export const url_get_data = "https://login.yandex.ru/info";
